import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";

type UpdateRecallChequeRequest = {
  pdcId: string;
  status: "approved" | "rejected";
};

const updateRecallChequeRequest = async (payload: UpdateRecallChequeRequest) => {
  const url = `${apiV1Endpoint}/booking/updateRecallChequeRequest`;

  const response = await axios.post<ApiResponse>(url, payload);
  return response.data.result;
};

type UseUpdateRecallChequeRequestOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useUpdateRecallChequeRequest = (options: UseUpdateRecallChequeRequestOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: updateRecallChequeRequest,
    onSuccess,
    onError,
  });

  return {
    updateRecallChequeRequest: mutateAsync,
    isPendingUpdateRecallChequeRequest: isPending,
  };
};
